/*
  BDEK "You might also like" (sections/bdek-product-recommendations.liquid)
  Fetches Shopify's related products for this product and shows them; stays hidden if there are none.
*/
(function () {
  function load(section) {
    if (section.dataset.bdekRecsReady) return;
    section.dataset.bdekRecsReady = 'true';
    var url = section.getAttribute('data-url');
    if (!url || !window.fetch) return;

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-bdek-recs-grid]');
        if (!fresh || !fresh.children.length) return;
        var grid = section.querySelector('[data-bdek-recs-grid]');
        grid.innerHTML = fresh.innerHTML;
        section.hidden = false;
      })
      .catch(function () {});
  }

  function initAll() {
    document.querySelectorAll('[data-bdek-recs]').forEach(load);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
